var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useCallback, useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { useTranslation } from "../../../../hooks/useTranslation";
import { CameraShutter, makeStyles, Typography } from "../../../../index";
import { CameraFlip } from "../../../../icons/index";
import { ImageEditorContainer } from "./ImageEditorContainer";
import { ROTATE_BUTTON_MARGIN } from "../constants/upload-image";
var CAMERA_IMAGE_TYPE = 'image/jpeg';
var useStyles = makeStyles(function (theme) { return ({
    root: {
        position: 'relative',
        height: '100%',
        overflow: 'hidden',
        flex: 1,
    },
    rootDisableCamera: {
        background: theme.palette.light.background.default,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    rootDefault: {
        background: theme.palette.dark.background.default,
    },
    rootEditing: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: theme.palette.light.background.default,
    },
    text: {
        fontSize: 18,
    },
    canvas: {
        display: 'none',
    },
    video: {
        position: 'absolute',
        height: '100%',
        left: 0,
        right: 0,
        margin: 'auto',
    },
    videoEditing: {
        display: 'none',
    },
    flipButton: {
        position: 'absolute',
        cursor: 'pointer',
    },
    flipIcon: {
        color: theme.palette.dark.text.primary,
    },
    shutterButton: {
        position: 'absolute',
        cursor: 'pointer',
    },
    shutterIcon: {
        color: theme.palette.primary.main,
        width: 64,
        height: 64,
    },
    imageEditingArea: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
    },
}); });
var initialButtonPosition = { left: 0, top: 0 };
export var Camera = function (props) {
    var _a, _b;
    var isIcon = props.isIcon, onChangeImageDataUrl = props.onChangeImageDataUrl;
    var _c = useState(initialButtonPosition), flipButtonPosition = _c[0], setFlipButtonPosition = _c[1];
    var _d = useState(initialButtonPosition), shutterButtonPosition = _d[0], setShutterButtonPosition = _d[1];
    var _e = useState('environment'), currentFacingMode = _e[0], setCurrentFacingMode = _e[1];
    var _f = useState(true), enableFlipButton = _f[0], setEnableFlipButton = _f[1];
    var _g = useState(), imageDataUrl = _g[0], setImageDataUrl = _g[1];
    var _h = useState(true), enableCamera = _h[0], setEnableCamera = _h[1];
    var classes = useStyles();
    var container = useRef(null);
    var canvas = useRef(null);
    var video = useRef(null);
    var flipButton = useRef(null);
    var shutterButton = useRef(null);
    var t = useTranslation().t;
    var getConstraints = function (facingMode) {
        return {
            audio: false,
            video: {
                facingMode: { exact: facingMode },
                width: 1280,
                height: 720,
            },
        };
    };
    var getAnotherFacingMode = function (facingMode) {
        return facingMode === 'environment' ? 'user' : 'environment';
    };
    var startCapture = useCallback(function (videoElement, facingMode) { return __awaiter(void 0, void 0, void 0, function () {
        var stream;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, navigator.mediaDevices.getUserMedia(getConstraints(facingMode)).catch(function () {
                        var anotherFacingMode = getAnotherFacingMode(facingMode);
                        setCurrentFacingMode(anotherFacingMode);
                        setEnableFlipButton(false); // 片方のカメラしか使えない場合は、カメラ切り替えボタンを非表示にする
                        return navigator.mediaDevices.getUserMedia(getConstraints(anotherFacingMode)).catch(function () {
                            setEnableCamera(false); // カメラが使えない場合
                            return null;
                        });
                    })];
                case 1:
                    stream = _a.sent();
                    if (!stream) {
                        return [2 /*return*/];
                    }
                    videoElement.srcObject = stream;
                    videoElement.play();
                    return [2 /*return*/];
            }
        });
    }); }, []);
    var stopCapture = function (videoElement) {
        if (videoElement.srcObject instanceof MediaStream) {
            videoElement.srcObject.getTracks().forEach(function (track) { return track.stop(); });
            videoElement.srcObject = null;
        }
    };
    var adjustButtonPosition = function () {
        var _a, _b, _c, _d, _e, _f, _g;
        var containerWidth = ((_a = container.current) === null || _a === void 0 ? void 0 : _a.clientWidth) || 0;
        var videoRect = (_b = video.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();
        var videoLeft = (videoRect === null || videoRect === void 0 ? void 0 : videoRect.left) || 0;
        var videoWidth = ((_c = video.current) === null || _c === void 0 ? void 0 : _c.clientWidth) || 0;
        var videoHeight = ((_d = video.current) === null || _d === void 0 ? void 0 : _d.clientHeight) || 0;
        var shutterButtonWidth = ((_e = shutterButton.current) === null || _e === void 0 ? void 0 : _e.clientWidth) || 0;
        var shutterButtonHeight = ((_f = shutterButton.current) === null || _f === void 0 ? void 0 : _f.clientHeight) || 0;
        var shutterButtonMargin = 16;
        var shutterButtonLeft = Math.min(videoLeft + videoWidth + shutterButtonMargin, containerWidth - shutterButtonWidth - shutterButtonMargin);
        var shutterButtonTop = (videoHeight - shutterButtonHeight) / 2;
        var flipButtonWidth = ((_g = flipButton.current) === null || _g === void 0 ? void 0 : _g.clientWidth) || 0;
        var flipButtonLeft = shutterButtonLeft + (shutterButtonWidth - flipButtonWidth) / 2;
        var flipButtonTop = shutterButtonTop - 80;
        setFlipButtonPosition({ left: flipButtonLeft, top: flipButtonTop });
        setShutterButtonPosition({ left: shutterButtonLeft, top: shutterButtonTop });
    };
    useEffect(function () {
        // 後処理実行時にvideo.currentがnullになる場合があるので、参照先を控えておく
        var videoElement = video.current;
        if (videoElement) {
            videoElement.onloadeddata = function () {
                adjustButtonPosition();
            };
            startCapture(videoElement, currentFacingMode);
        }
        return function () {
            if (videoElement) {
                stopCapture(videoElement);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(function () {
        adjustButtonPosition();
        var onResize = function () {
            adjustButtonPosition();
        };
        window.addEventListener('resize', onResize);
        return function () {
            window.removeEventListener('resize', onResize);
        };
    }, []);
    var handleClickFlipButton = useCallback(function () {
        if (!video.current) {
            return;
        }
        stopCapture(video.current);
        var anotherFacingMode = getAnotherFacingMode(currentFacingMode);
        setCurrentFacingMode(anotherFacingMode);
        startCapture(video.current, anotherFacingMode);
    }, [currentFacingMode, startCapture]);
    var handleClickShutterButton = useCallback(function () {
        if (canvas.current && video.current) {
            var context = canvas.current.getContext('2d');
            if (context) {
                canvas.current.width = video.current.clientWidth;
                canvas.current.height = video.current.clientHeight;
                context.drawImage(video.current, 0, 0, video.current.clientWidth, video.current.clientHeight);
                var dataUrl = canvas.current.toDataURL(CAMERA_IMAGE_TYPE);
                updateImageArea();
                setImageDataUrl(dataUrl);
                onChangeImageDataUrl === null || onChangeImageDataUrl === void 0 ? void 0 : onChangeImageDataUrl(dataUrl);
            }
        }
    }, [onChangeImageDataUrl, canvas, video]);
    var handleClickChangeButton = useCallback(function () {
        setImageDataUrl(undefined);
        onChangeImageDataUrl === null || onChangeImageDataUrl === void 0 ? void 0 : onChangeImageDataUrl(undefined);
        if (video.current) {
            stopCapture(video.current);
            startCapture(video.current, currentFacingMode);
        }
    }, [currentFacingMode, onChangeImageDataUrl, startCapture]);
    var imageEditingArea = useRef(null);
    var _j = useState({ width: 0, height: 0 }), imageSize = _j[0], setImageSize = _j[1];
    var updateImageArea = function () {
        var _a;
        var rect = (_a = container.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        // imageSizeの幅は、両側に回転ボタンが入るだけのマージンを確保する必要がある
        if (rect) {
            setImageSize({
                width: Math.max(rect.right - rect.left - ROTATE_BUTTON_MARGIN * 2, 0),
                height: rect.bottom - rect.top,
            });
        }
    };
    useEffect(function () {
        var onResize = updateImageArea;
        onResize();
        window.addEventListener('resize', onResize);
        return function () {
            window.removeEventListener('resize', onResize);
        };
    }, [imageDataUrl]);
    if (!enableCamera) {
        return (React.createElement("div", { className: classNames(classes.root, classes.rootDisableCamera) },
            React.createElement(Typography, { className: classes.text }, t('カメラがブロックされています'))));
    }
    return (React.createElement("div", { className: classNames(classes.root, (_a = {},
            _a[classes.rootDefault] = imageDataUrl === undefined,
            _a[classes.rootEditing] = imageDataUrl !== undefined,
            _a)), ref: container },
        React.createElement("video", { className: classNames(classes.video, (_b = {},
                _b[classes.videoEditing] = imageDataUrl !== undefined,
                _b)), ref: video, onContextMenu: function (e) { return e.preventDefault(); } }),
        imageDataUrl ? (React.createElement("div", { className: classes.imageEditingArea, ref: imageEditingArea },
            React.createElement(ImageEditorContainer, { isIcon: isIcon, editorMaxWidth: imageSize.width, editorMaxHeight: imageSize.height, imageDataUrl: imageDataUrl, imageType: CAMERA_IMAGE_TYPE, changeButtonLabel: t('撮り直す'), onChangeImageDataUrl: onChangeImageDataUrl, onChangeButtonClick: handleClickChangeButton }))) : (React.createElement(React.Fragment, null,
            React.createElement("canvas", { className: classes.canvas, ref: canvas }),
            React.createElement("img", { className: classes.video, src: imageDataUrl }),
            flipButtonPosition !== initialButtonPosition && enableFlipButton && (React.createElement("div", { className: classes.flipButton, style: flipButtonPosition, ref: flipButton, onClick: handleClickFlipButton },
                React.createElement(CameraFlip, { className: classes.flipIcon }))),
            shutterButtonPosition !== initialButtonPosition && (React.createElement("div", { className: classes.shutterButton, style: shutterButtonPosition, ref: shutterButton, onClick: handleClickShutterButton },
                React.createElement(CameraShutter, { className: classes.shutterIcon })))))));
};
